import { ChangeDetectorRef, Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { SaleHorseNoteModel } from '../../models/sales/sale-horse-note.model';
import { SalesService } from '../../services/sales.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { DateParserFormatter } from '../../utils/helper/date-parser-formatter';

@Component({
  selector: 'app-sale-horse-internal-note-popup',
  templateUrl: './sale-horse-internal-note-popup.component.html',
  styleUrls: ['./sale-horse-internal-note-popup.component.scss']
})
export class SaleHorseInternalNotePopupComponent extends BaseUnsubscribeComponent implements OnInit {

  @Input() public data: any;
  public internalNoteForm: FormGroup;
  public submitted = false;
  public isListMode = true;
  private selectedId = 0;
  public isLoader = false;
  public dataSource: MatTableDataSource<SaleHorseNoteModel>;
  @ViewChild(MatTable) table: MatTable<SaleHorseNoteModel>;
  public displayedColumns$ = new BehaviorSubject([
    'notes',
    'user',
    'date',
    'action'
  ]);
  constructor(
    public readonly modal: NgbActiveModal,
    private readonly formBuilder: FormBuilder,
    private readonly saleService: SalesService,
    @Inject(DateParserFormatter) private dateParserFormatter: DateParserFormatter,
    private changeDetectorRefs: ChangeDetectorRef
  ) {
      super();
  }

  closePopup(): void {
    this.modal.close(JSON.stringify(this.data));
  }
  public getNote(id: number): void {
    this.isLoader = true;
    this.saleService.getSaleHorseNote(id).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.isLoader = false;
      this.selectedId = id;
      this.isListMode = false;
      this.internalNoteForm.patchValue({ note: response.notes });
    });
  }
  public getDefaultDateFormat() {
    return this.dateParserFormatter.getDefaultDateTimeFormat(false);
  }
  public formSubmit(): void {
    this.submitted = true;

    if (this.internalNoteForm.invalid) {
      return;
    }

    let formData = this.internalNoteForm.value;
    this.data.id = this.selectedId;
    this.data.note = formData.note;
    this.isLoader = true;
    this.modal.close(JSON.stringify(this.data));
    
  }

  cancel() {
    this.isListMode = true;
    this.selectedId = 0;
  }
  add() {
    this.isListMode = false;
    this.selectedId = 0;
    this.internalNoteForm.patchValue({ note: "" });
  }

  public ngOnInit(): void {
    this.isLoader = true;
    this.saleService.getSaleHorseNotes(this.data.saleId, this.data.horseId).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.isLoader = false;
      this.dataSource = new MatTableDataSource<SaleHorseNoteModel>(response);
    });
    this.internalNoteForm = this.formBuilder.group({
      note: ['', [Validators.required]]
    });
  }

  public deleteSaleHorseNote(id: number) {
    this.isLoader = true;

    this.saleService.deleteSaleHorseNote(id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (response) => {
          // Assuming the delete operation was successful, find and remove the record from the dataSource
          const index = this.dataSource.data.findIndex(note => note.id === id);

          if (index !== -1) {
            this.dataSource.data.splice(index, 1);  // Remove the item from the array
            this.dataSource.data = [...this.dataSource.data];  // Refresh the dataSource
            this.table.renderRows();
            this.changeDetectorRefs.detectChanges();
          }

          this.isLoader = false;
        },
        (error) => {
          // Handle error if needed
          console.error('Error deleting sale horse note:', error);
          this.isLoader = false;
        }
      );
  }

}
